import React from 'react';
//prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import MDBox from "common/components/MD/MDBox";
import { MenuItem, Select } from '@mui/material';

//filtro per Area Riservata abilitata o no

export const SelectColumnFilterAR = ({ column }) => {

  const { filterValue, setFilter } = column

const handleChange=(val)=>{

 switch(val) {
      case "OK":
        setFilter("OK"); // Usa un identificatore testuale
        break;
      case "KO":
        setFilter("KO"); // Usa un identificatore testuale
        break;
      default:
        setFilter(undefined);
    }
}


  return (

    <MDBox ml="auto">

      <Select name="stato_ar" id="stato_ar"
        onChange={e => {
          sessionStorage.setItem("filter_"+column.id,e.target.value);  
          handleChange(e.target.value);
        }}
        value={filterValue || ''}
      >
        <MenuItem key="TUTTO" value="">TUTTO</MenuItem>
        <MenuItem key="OK" value="OK">ABILITATA</MenuItem>
        <MenuItem key="KO" value="KO">NON ABILITATA</MenuItem>
        </Select>


    </MDBox>
  )

}

// Setting default values for the props of DataTable
SelectColumnFilterAR.propTypes = {

  filter: PropTypes.string,
  setFilter: PropTypes.func,
};

// Typechecking props for the DataTable
SelectColumnFilterAR.defaultProps = {
  filter: '',
  setFilter: null,
};